import {
  ProductPayload,
  ADD_WIDGET,
  ADD_PACKAGE,
  CLEAR_PRODUCT,
  UPDATE_WIDGET
} from "./types";

const initialState: any = {};

export function productReducer(
  state = initialState,
  action: ProductPayload
) {
  switch (action.type) {
    case ADD_WIDGET: {
      const { formId, widget } = action.data
      const product = state[formId] || {}
      const existingWidgets = product.widgets || []
      return {
        ...state,
        [formId]: {
          ...product,
          widgets: [...existingWidgets, widget],
        }
      }
    }
    case UPDATE_WIDGET: {
      const { formId, id, previousWidgetState, previousPackageState } = action.data;
      
      // Create a new object to avoid mutating the state directly
      const product = { ...state[formId] };
      const existingWidgets = product.widgets || [];
      const existingPackages = product.packages || {};
      let hasMatchingCustomWidget = false;

      // Check if the widget ID exists in the existing widgets
      if (!existingWidgets.some((widget: { json: { productId: string; }; }) => widget.json.productId === id)) {
      
        // Check if the widget ID exists in the existing packages
        if (typeof existingPackages === 'object' && !Array.isArray(existingPackages)) {
          const PackageKey = Object.keys(existingPackages)[0];
          const firstPackage = existingPackages[PackageKey];
          if (Array.isArray(firstPackage)) {
            hasMatchingCustomWidget = firstPackage.some((widget: any) => widget?.json?.productId === id);
          } else if (firstPackage && Array.isArray(firstPackage.PackagesRe)) {
            hasMatchingCustomWidget = firstPackage.PackagesRe.some((widget: any) => widget?.json?.productId === id);
          }
        } else if (Array.isArray(existingPackages)) {
          hasMatchingCustomWidget = existingPackages.some((pkg: any) =>
            Array.isArray(pkg.PackagesRe) &&
            pkg.PackagesRe.some((widget: any) => widget?.json?.productId === id)
          );
        }
      }

      // maintaing the value for widgets
      if (previousWidgetState) {
        product.widgets = [previousWidgetState, ...existingWidgets.filter((widget: { json: { productId: any; }; }) => widget.json.productId !== id)];
      } else {
        product.widgets = existingWidgets.filter((widget: { json: { productId: any; }; }) => widget.json.productId !== id);
      }

      // maintaing the value for packages
      let PackagesRe = [];
      if (previousPackageState) {
        for (const key in previousPackageState) {
          if (previousPackageState.hasOwnProperty(key)) {
            PackagesRe = previousPackageState[key];
            break;
          }
        }
      } else {
        const existingPackagesKeys = Object.keys(existingPackages);
        for (const key of existingPackagesKeys) {
          const widgets = existingPackages[key].filter((widget: { json: { productId: any; }; }) => widget.json.productId !== id);
          if (widgets.length > 0) {
            PackagesRe = widgets;
            break;
          }
        }
      }

      // Create a new object with the existing key and the updated value
      product.packages = {
        [Object.keys(previousPackageState || existingPackages)[0]]: PackagesRe
      };

      return {
        ...state,
        [formId]: product,
      };
    }
    case ADD_PACKAGE: {
      const { formId, pkg } = action.data
      const product = state[formId] || {}
      const existingPackages = product.packages || {}
      return {
        ...state,
        [formId]: {
          ...product,
          packages: {...existingPackages, ...pkg},
        }
      }
    }
    case CLEAR_PRODUCT: {
      return {
        ...state,
        [action.data]: {
          widgets: [],
          packages: {},
        }
      }
    }
    default:
      return state
  }
}
